import React from 'react';

const HomeFourAbout = () => {
   return (
      <>
         <section className="about-area pt-130 pb-100">
            <div className="container">
               <div className="row">
                  <div className="col-xl-6 col-lg-5">
                     <div className="h4about-thumb pos-rel">
                        <img src="img/home4/about/about__thumb.jpg" alt="" />
                        <a href="tel:+919120009066" className="call-btn f-700 white-color green-bg">
                           <i className="call-icon"><img src="img/home4/icon/about__phone__icon.png" alt="" />
                           </i><span>+91 9120009066</span></a>
                        <img src="img/home4/about/overlap.jpg" alt="" className="about-overlap__thumb" /> </div>
                  </div>
                  <div className="col-xl-6 col-lg-7">
                     <div className="about-right-side h4about-right mb-30">
                        <div className="about-title mb-20">
                           <h5 className="pink-color">About Octavia Hospitals</h5>
                           <h1>We Are Best In Services</h1>
                        </div>
                        <div className="about-text">
                           <p className="theme-color">Octavia hospitals are the best-in-class multi-specialty hospitals that provide all-around care for every ailing individual. With updated infrastructure and a team of extremely reputed and experienced doctors, we are relentlessly working on diminishing every ailment. We not only provide you with the best of facilities but also make sure that your loved ones are taken good care of and provided with the warmth of togetherness.</p>
                           <p className="mb-20">With spacious interiors and wards, we provide comfortable seating and ventilated private rooms. We specialize in technology-aided equipment that helps in performing procedures efficiently. Octavia Hospital is committed to providing immediate assistance to everyone in need without wasting time or energy on minuscule formalities, giving treatment the first priority over anything else.</p>
                        </div>
                        
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeFourAbout;